"use strict";

exports.__esModule = true;
exports.AlertDefinitionPanel = void 0;
var _core = require("@blueprintjs/core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _AlertDefinitionContext = require("../AlertDefinitionContext/AlertDefinitionContext");
var _AlertDefinitionController = require("../AlertDefinitionContext/AlertDefinitionController");
var _Common = require("../Common");
var _styles = require("../styles");
var _vimanaTypes = require("@vimana/vimana-types");
var _AlertTagsInput = require("../AlertTagsInput");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AlertDefinitionPanel = exports.AlertDefinitionPanel = function AlertDefinitionPanel(props) {
  var _alert$conditions;
  var alerts = (0, _react.useContext)(_AlertDefinitionContext.AlertDefinitionContext);
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var index = props.index;
  var alert = props.alert || alerts.getAlert(index);
  var setConditions = function setConditions(conditions) {
    alerts.setAlert(Object.assign({}, alert, {
      conditions: conditions
    }), index);
  };
  var updateCondition = function updateCondition(condition, index, array) {
    return function (self) {
      array.splice(index, 1, self);
      setConditions(array);
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, {
    style: {
      width: "100%",
      height: "30px",
      marginTop: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.InputText, null, translate("AlertDefinition.Panel.AlertName", "Alert name")), /*#__PURE__*/_react["default"].createElement(_styles.Input, null, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
    style: {
      minWidth: "200px"
    },
    id: "alert-alertName-value"
  }, (!(0, _utils.validateEmptyField)(alert.alertName) || !(0, _utils.validateAlertName)(alert.alertName)) && {
    intent: _core.Intent.DANGER
  }, {
    "data-testid": "AlertDefinition.AlertDefinitionPanel.AlertNameValue-" + index,
    type: "text",
    value: alert.alertName,
    disabled: props.disableAlertNameInput,
    onChange: function onChange(_ref) {
      var target = _ref.target;
      return alerts.setAlert(Object.assign({}, alert, {
        alertName: target.value
      }), index);
    }
  })))), /*#__PURE__*/_react["default"].createElement(_AlertTagsInput.AlertTagsInput, {
    alert: alert,
    setAlertTags: function setAlertTags(tags) {
      return alerts.setAlert(Object.assign({}, alert, {
        tags: tags
      }), index);
    },
    disabled: props.disableAlertTagsInput
  }), /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, {
    style: {
      width: "100%",
      height: "30px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.InputText, null, translate("AlertDefinition.Panel.AlertDescription", "Alert Description")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "calc(100% - 135px)"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
    id: "alert-condition-description"
  }, !(0, _utils.validateEmptyField)(alert.description) && {
    intent: _core.Intent.DANGER
  }, {
    "data-testid": "AlertDefinition.AlertDefinitionPanel.FilterDescription-" + index,
    type: "text",
    value: alert.description,
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return alerts.setAlert(Object.assign({}, alert, {
        description: target.value
      }), index);
    },
    disabled: props.disableAlertDescriptionInput
  })))), /*#__PURE__*/_react["default"].createElement(_Common.ConditionPanel, {
    errorMessage: translate("EnrichEditorUI.AlertDefinitionPanel.Validation.ConditionRequiredInfo", "Alert needs at least one condition"),
    conditions: (_alert$conditions = alert.conditions) != null ? _alert$conditions : [],
    updateCondition: updateCondition,
    setConditionArray: setConditions,
    classifyName: "alert",
    isTypeDataItemOnly: true
  }));
};